import React, { Component } from 'react';

class AboutMe extends Component {
  render() {
    return (
    <div className="page max-height" id={this.props.id}>
        <div className="page-container">
            <h2>About Me</h2>
            <p className='basic-text'>
                Hi, my name is Florian Mathieu. <br/>

                Passionate about IT, art, music and indie video games. I've been making games for over 6 years primarily in Unity<br/>
                I'm currently a student in 3rd year of game development at Gaming Campus Lyon.<br/>
                <br/>
                Go check out my projects below !<br/>
            </p>
        </div>
    </div>
    );
  }
}

export default AboutMe;